<template>
  <v-container class="login-page">
    <div class="my-4 form-header text-xs-right">
      <div class="logo">
        <img draggable="false" :src="require('@/assets/soae.png')" alt="Logo" />
        <p>Comunicação</p>
      </div>
    </div>
    <v-layout justify-center align-center>
      <v-flex xs12 sm5 lg4>
        <v-card class="login-form mt-2">
          <v-card-title>
            <div>
              <p class="primary--text ma-0 py-2 form-title headline">Entrar</p>
            </div>
          </v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="canSend">
              <v-text-field
                v-model="email"
                :rules="[v => !!v || 'Este campo é obrigatório.']"
                :disabled="isLoading"
                label="Usuário"
                autocomplete="email"
                @keyup.enter="login()"
              />
              <v-text-field
                v-model="password"
                :rules="[v => !!v || 'Este campo é obrigatório.']"
                :disabled="isLoading"
                label="Senha"
                type="password"
                autocomplete="off"
                @keyup.enter="login()"
              />
              <v-layout wrap align-center class="my-2">
                <v-flex xs6>
                  <router-link to="/esqueci-senha" class="flex-auto"
                    >Esqueceu a senha?</router-link
                  >
                </v-flex>
                <v-flex xs6 class="text-xs-right">
                  <v-btn
                    :disabled="isLoading"
                    color="primary"
                    class="flex-auto btn-entrar"
                    @click="login"
                    >Entrar</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
        </v-card>
        <p class="text-xs-center my-4">
          {{ new Date().getFullYear() }}&copy; Linkdesign
        </p>
      </v-flex>
    </v-layout>
    <v-snackbar v-model="snackbar" :color="cor ? cor : ''">
      {{ text }}
      <v-btn color="primary" text @click="snackbar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { Auth } from '../service'
import CryptoJS from 'crypto-js'

export default {
  data() {
    return {
      canSend: null,
      email: '',
      password: '',
      isLoading: false,
      escola: '',
      cor: '',
      snackbar: false,
      text: ''
    }
  },
  created() {},
  mounted() {
    this.getDomain()
    this.getSuccess()
    if (Auth.isAuthenticated) {
      this.continueNavigation()
    } else {
      Auth.logout(false)
    }
  },
  methods: {
    continueNavigation() {
      const redirect = this.$route.query.redirect
      this.$router.push(redirect)
    },
    login() {
      if (this.$refs.form.validate()) {
        this.isLoading = true
        Auth.login(
          this.email,
          CryptoJS.MD5(this.password).toString(),
          this.escola
        )
          .then(() => this.continueNavigation())
          .catch(() => {
            this.isLoading = false
            this.snackbar = true
            this.cor = 'error'
            this.text = 'Usuário e/ou senha inválidos. Tente novamente'
          })
      }
    },
    getDomain() {
      try {
        if (this.$route.query.escola != null) {
          localStorage.setItem('escola', this.$route.query.escola)
        }
        this.escola = localStorage.getItem('escola')
      } catch (e) {
        console.log(e)
      }
    },
    getSuccess() {
      if (localStorage.getItem('passreset') == 'success') {
        setTimeout(() => {
          this.snackbar = true
          this.text = 'Senha alterada com sucesso'
          this.cor = 'success'
        }, 2000)
        localStorage.removeItem('passreset')
      }
    }
  }
}
</script>

<style lang="stylus">
a {
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.form-header {
  text-align: center;
  max-width: 180px;
  margin: 0 auto;

  img {
    width: 55%;
    margin-bottom: 5px;
  }

  p {
    font-weight: bold;
    font-size: 14;
    color: #888;
    line-height: 0;
  }
}

.form-title {
  font-weight: bold;
}

.btn-entrar {
  float: right;
}
</style>
